import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  getModulesSuccess,
  getModulesFailure,
  showModulesSuccess,
  showModulesFailure,
  createModulesSuccess,
  createModulesFailure,
  updateModulesSuccess,
  updateModulesFailure,
} from "../../actions";
import {
  GET_MODULES,
  SHOW_MODULES,
  UPDATE_MODULES,
  CREATE_MODULES,

} from "../../Actions/types";
import api from "../../../helper/api";
import axios from 'axios';
import { deleteCookies, getCookies } from "../../../helper/constant";

// function* fetchModules(action) {
//   try {
//     const response = yield api.get(
//       "/admin/role/fetch",
//       action?.payload?.payload,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );
//     if (response?.status === 200 && response?.data?.status === 200) {
//       yield put(getModulesSuccess({ getData: response?.data?.data }));
//       yield call(action?.payload?.callback, response?.data?.data);
//     } else {
//       toast.error(response?.data?.message);
//     }
//   } catch (e) {
//     toast.error(e?.response?.data?.message);
//     yield put(getModulesFailure({ getError: e }));
//   }
// }






function* showModules(action) {
  
  try {
    // const response = yield api.post(
    //   "/admin/subadmin/show",
    //   action?.payload?.form,
    //   {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   }
    // );
    const response = yield api.get(`admin/listPermission`);
    
    if (response?.status === 200 && response?.data?.status === "success") {
      
      yield call(action?.payload?.callback, response?.data?.data?.permission);
      yield put(showModulesSuccess({ showData: response?.data?.data?.permission }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(showModulesFailure({ showError: e }));
  }
}


// function* ModuleWatcher() {
//   yield takeLatest(GET_MODULES, fetchModules);
// }
function* showModuleWatcher() {
  yield takeLatest(SHOW_MODULES, showModules);
}


export default function* ModuleSaga() {
  yield all([
    // ModuleWatcher(),
    showModuleWatcher(),
  ]);
}
